import { Component } from '@angular/core';

@Component({
    selector: 'app-icon-pixel',
    templateUrl: './icon-pixel.component.pug',
    styleUrls: ['./icon-pixel.component.less']
})
export class IconPixelComponent {
    value: string = '';

    constructor(
    ) {
    }

    setValue(value: any) {
        this.value = value.toString();
    }
}
